import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import YouTube from 'react-youtube'


export default class extends React.Component {
    static propTypes = {
		description: PropTypes.string,
		image: PropTypes.string,
		title: PropTypes.string,
		url: PropTypes.string,
		video: PropTypes.string.isRequired,
	};

    render() {

		let matches = this.props.video.match(/(youtu(?:\.be|be\.com)\/(?:.*v(?:\/|=)|(?:.*\/)?)([\w'-]+))/),
			youtubeID = !!matches.length ? matches[2] : '';

		return (
	 		<div className="mbot20" ref="video_wrapper">
		 		<div className="row">
			 		<div className="col-sm-12">
			 			<Link to={this.props.url}>
			 				<div className="embed-responsive embed-responsive-16by9">
								<YouTube
									videoId={youtubeID}
									className="embed-responsive-item"
									opts={{
										//height: this.props.video.height,
									    //width: this.props.video.width,
									    playerVars: { //https://developers.google.com/youtube/player_parameters
								        	autoplay: 0,
								        	controls: 1,
								        	showinfo: 0,
								        	modestbranding: 0,
								        	rel: 0
								    	}
									}}
								/>
							</div>
						</Link>
					</div>
			 		<div className="col-sm-12">
			 			<h4><Link to={this.props.url}>{this.props.title}</Link></h4>
			 		</div>
		 		</div>
		 	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/PreviewParts/VideoPreview.jsx